import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import swal from 'sweetalert2';
import moment from 'moment';

const AddProductCategory = ({isShow, editInformation, saveFunc, toggleFunc}) => {
  const { reason} = editInformation;
  const [dropReason, setDropReason] = useState('1');
  const [productIds, setProductIds] = useState('');
  const handleDropReason = (e) => {
    setDropReason(e.target.value)

  }
  function containsChinese(str) {
    return /[\u4E00-\u9FAF]/.test(str);
}
    return (
      <div className="u-editblock fadeIn" style={{display: isShow === true ? 'flex' : 'none'}}>
        <div className="form-block" style={{minWidth: '400px'}}>
          <div className="u-small-title">新增/編輯品項</div>
          <form className="u-form">
          <div className="row">
                      <div className="col-5 col-pad-12">
                        <select className="u-form__select" style={{marginLeft:'5px',marginTop:'8px'}} value={dropReason} onChange={handleDropReason}>
                        <option key="1" value="1">餐點</option>
                        <option key="2" value="2">飲料</option>
                        <option key="3" value="3">甜點</option>
                        <option key="4" value="4">包場</option>
                        <option key="5" value="5">商品</option>
                        <option key="6" value="6">其他</option>
                        </select>
                      </div>
                    </div>
            <div className="row m-t-16">
              <div className="col-12 col-pad-12">
                <label className="u-form__label text-align-right">產品編號：</label>
                <input required={true} value={productIds} onChange={(e)=>{setProductIds(e.target.value);}} className="u-form__input underline"/>
              </div>
              <div className="col-12 col-pad-12">
                <label className="u-form__label text-align-right">備註:逗號可輸入多筆，例:A001001,A001002</label>
              </div>
            </div>
            
            <div className="u-btn-group right">
              <button className="btn btn-md save" onClick={(e) => {
                e.preventDefault();
                if(containsChinese(productIds)){
                  alert('字串內含中文字');
                  return;
                }

                saveFunc(dropReason,productIds);
                setProductIds('')
                setDropReason('1')
              }}>送出</button>
              <button className="btn btn-md cancel m-l-16" onClick={
                (e) => {
                  e.preventDefault();
                  setProductIds('')
                  setDropReason('1')
                  toggleFunc();
                }
              }>取消</button>
            </div>
          </form>
        </div>
      </div>
    )

  }

export default AddProductCategory;